const intialState = {
  userType: {} as any,
  loading: false,
  error: null
};

const userTypeReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_USER_TYPE_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'GET_USER_TYPE_SUCCESS':
      return {
        ...state,
        loading: false,
        userType: action.payload.data
      };
    case 'GET_USER_TYPE_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
};
export default userTypeReducer;
